import useSWR from "swr"
import {API_ECP_PROJECTS} from "../constants/apiUrls"

export default function useStTranscription(projectId) {
    const {data, mutate, error} = useSWR(`${API_ECP_PROJECTS}/${projectId}/transcription`, {revalidateOnFocus: false})
    return {
        stProjectTranscription: data,
        mutateStProjectTranscription: mutate,
        isLoadingStProjectTranscription: !error && !data,
        isErrorStProjectTranscription: error
    }
}